import { render, staticRenderFns } from "./administrativeArea.vue?vue&type=template&id=2e75632f"
import script from "./administrativeArea.vue?vue&type=script&lang=js"
export * from "./administrativeArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e75632f')) {
      api.createRecord('2e75632f', component.options)
    } else {
      api.reload('2e75632f', component.options)
    }
    module.hot.accept("./administrativeArea.vue?vue&type=template&id=2e75632f", function () {
      api.rerender('2e75632f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/administrativeArea/administrativeArea.vue"
export default component.exports